import { render, staticRenderFns } from "./ResultsView.vue?vue&type=template&id=5a0c0fc2&"
import script from "./ResultsView.vue?vue&type=script&lang=ts&"
export * from "./ResultsView.vue?vue&type=script&lang=ts&"
import style0 from "./ResultsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a0c0fc2')) {
      api.createRecord('5a0c0fc2', component.options)
    } else {
      api.reload('5a0c0fc2', component.options)
    }
    module.hot.accept("./ResultsView.vue?vue&type=template&id=5a0c0fc2&", function () {
      api.rerender('5a0c0fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/results/ResultsView.vue"
export default component.exports